// extracted by mini-css-extract-plugin
export default {"Photo":"Photo_GSxcl","buttons":"buttons_UjQ5z","PhotoPending":"PhotoPending_UUZ-T"};